var exports = {
  "i": "xe533113f--f7672d--wrapper",
};

module.exports = exports;
